import axios from "axios";
export const LAST_URL = "LAST_URL";



export const getTest = (test) => {
    // Change test object
    return test;
};

export const connection = (data) => {
    let loginFormData = new FormData();

    loginFormData.append("email", data.email);
    loginFormData.append("password", data.password);
    loginFormData.append("remember", data.remember);

    return new Promise((resolve, reject) => {
      axios
        .post('/login', loginFormData)
        .then( (response) => {
            if(response.data.data.remember){
              localStorage.setItem("access_token", response.data.data.token);
              localStorage.setItem("user_id", response.data.data.user_id);
            }

            resolve(response);
        })
        .catch( (error) => {
          reject(error.response);
        });
    });
  };

export const resent = (email) => {
    let emailFormData = new FormData();

    emailFormData.append("email", email);
  
    return new Promise((resolve, reject) => {
      axios
        .post('/email/verify/resend', emailFormData)
        .then( (response) => {

          resolve(response.data);

        })
        .catch( (error) => {
          reject(error.response.data);
        });
    });
  };

  export const registration = (data) => {

    let registerFormData = new FormData();

    registerFormData.append("username", data.username);
    registerFormData.append("first_name", "");
    registerFormData.append("last_name", "");
    registerFormData.append("email", data.email);
    registerFormData.append("password", data.password);
    registerFormData.append("password_confirmation", data.password_confirmation);
    registerFormData.append("question", "");
    registerFormData.append("answer", "");
  
    return new Promise((resolve, reject) => {
      axios
        .post('/register', registerFormData)
        .then( (response) => {
          resolve(response);
        })
        .catch( (error) => {
          reject(error.response.data);
        });
    });
  };

  export function getLoginUrl(provider) {

    return new Promise((resolve, reject) => {
        axios
            .get(`/login/redirect/${provider}`)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error.response.data);
            });
    });
}

export function socialCallback(search, provider) {

  return new Promise((resolve, reject) => {
      axios
          .get(`/login/${provider}/callback${search}`)
          .then((response) => {
              if(response.data.data.remember){
                
                localStorage.setItem("access_token", response.data.data.token);
                localStorage.setItem("user_id", response.data.data.user_id);
              }else{
                sessionStorage.setItem("access_token", response.data.data.token);
                sessionStorage.setItem("user_id", response.data.data.user_id);
              }
              resolve(response);
          })
          .catch((error) => {
              reject(error.response.data);
          });
  });
}

export const validateOtp = (otp) => {

    let registerFormData = new FormData();

    registerFormData.append("otp", otp);

    return new Promise((resolve, reject) => {
        axios
            .post('/validate/otp', registerFormData)
            .then( (response) => {
                resolve(response.data);
            })
            .catch( (error) => {
                reject(error.response);
            });
    });
};


export const checkConnect = () =>{
  let local = localStorage.getItem("access_token")
  console.log("La data")
  console.log(local)
      if(local !== null && local !== undefined && local !== "undefined"){
          try {
              let result = localStorage.getItem("user");
              console.log(result)
              return result
              //setUser(result);
              //setConnected(true);
              localStorage.setItem('isLogged', true)
          } catch (error) {
          }
      }else{
          console.log("false false")
          //setConnected(false);
          localStorage.setItem('isLogged', false)

      }
}

export const getLastUrl = () =>{
  return localStorage.getItem(LAST_URL)
}
